'use client'

import {
  captureTracewayException,
  getTracewayHeaders,
  getTracewayRelease,
  getTracewayRuntime,
  initializeTracewayClient,
  recordTracewayAuthEvent,
  recordTracewayBreadcrumb,
  recordTracewayChatEvent,
  recordTracewayNavigation,
  recordTracewayRequestEvent,
  recordTracewayWebSocketEvent,
} from '@/lib/traceway-client'

export {
  captureTracewayException,
  getTracewayHeaders,
  getTracewayRelease,
  getTracewayRuntime,
  initializeTracewayClient,
  recordTracewayAuthEvent,
  recordTracewayBreadcrumb,
  recordTracewayChatEvent,
  recordTracewayNavigation,
  recordTracewayRequestEvent,
  recordTracewayWebSocketEvent,
}

